'use client';

import { Box, Container } from '@mui/material';
import { BlocksContent } from '@strapi/blocks-react-renderer';

import GlobalBlockRenderer from '@/components/ContentBlocks/GlobalBlockRenderer/GlobalBlockRenderer';
import { CustomBackground } from '@/components/CustomBackground/CustomBackground';
import { ImageUrl } from '@/components/Utility/StrapiImage';
import { UploadFile } from '@/types';

interface HeroMissionValuesProps {
  heroText?: BlocksContent;
  heroImage?: UploadFile;
}

export default function HeroMissionValues(props: HeroMissionValuesProps) {
  return (
    <>
      {props.heroImage && (
        <Box
          sx={{
            height: 350,
            background: `url(${ImageUrl({
              image: props.heroImage,
              size: 'large',
            })}) center 65% no-repeat`,
            backgroundSize: 'cover',
          }}
        ></Box>
      )}
      <CustomBackground
        backgroundOptions={{
          BackgroundColor: 'purple-800',
        }}
        displayOptions={{
          PaddingTop: 'sm',
          PaddingBottom: 'sm',
          CenterAlignTitles: true,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            position: 'relative',
            zIndex: 1,
          }}
        >
          <GlobalBlockRenderer content={props.heroText || []} />
        </Container>
      </CustomBackground>
    </>
  );
}
